import React from 'react'
import ClientDetails from '../features/client-details/client-details'

const Clientdetails =() =>{
  return (
   <ClientDetails/>
  )
}

export default  Clientdetails
